import { Component, OnInit, Input, HostListener } from '@angular/core';
import { animationShowHide, fabButtonsAnimation } from 'src/app/utils/animations';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { ControllerStatusService } from 'src/app/services/controller-status.service';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { FabButton } from './fab-button';
import { deepCopy } from 'src/app/utils/deep-copy';

@Component({
	selector: 'fab-buttons',
	templateUrl: './fab-button.component.html',
	styleUrls: ['./fab-button.component.scss'],
	animations: [fabButtonsAnimation, animationShowHide]
})
export class FabButtonComponent implements OnInit {

	@Input() fabButtons: FabButton[] = [];
	public buttons: FabButton[] = [];

	public fabTogglerState = 'inactive';
	public isMenuOpen: boolean = false;

	constructor(private icons: RegisterIconsService, public controllerStatus: ControllerStatusService, private apiUsuario: ApiUsuarioService) {
		icons.registerIcons(['plus'])
	}

	ngOnInit(): void {
		this.verificaButtons();
	}

	public handleItemClick = (btn: FabButton, event: Event) => {
		event.stopPropagation();
		
		const {open, url} = btn;

		console.log('btn: ', btn);

		if (btn.children) {
			this.toggleSubItems(btn);
		} else {
			open(url);
			this.onToggleFab();
		}
	}

	public handleSubItemClick = (subItem: FabButton, event: Event) => {
		event.stopPropagation();

		if (subItem.open) {
			subItem.open(subItem.url);
			this.onToggleFab();
		}
	}

	private toggleSubItems = (clickedBtn: FabButton) => {

		// Abre o que foi clicado e fecha todos os outros subMenus
		this.buttons.forEach(btn => {

			if (btn.id !== clickedBtn.id) {
				btn.showChildren = false;
				return;
			}

			clickedBtn.showChildren = !clickedBtn.showChildren;
		})
	}

	public onToggleFab() {
		this.isMenuOpen = !this.isMenuOpen;
		this.fabTogglerState = this.isMenuOpen ? 'active' : 'inactive';

		if (!this.isMenuOpen) {
			this.closeMenu();
			return;
		}

		this.openMenu();
	}

	private openMenu = () => {
		this.buttons = deepCopy(this.fabButtons); // Cria uma cópia da array principal de itens. Necessária pois a nível de componente vamos precisar fazer alterações que não serão aplicadas externamente. Ex: Foi implementado que o submenu de "automóvel" iniciará aberto, no entanto, quando o usuário fecha o submenu, todos os submenus são fechados. Dado esse comportamento não podemos usar a mesma array que inicia os itens pois os próprios teriam sido alterados. 
	}
	
	private closeMenu = () => {
		this.clearButtonsArray();
	}

	private clearButtonsArray = () => {
		this.buttons = [];
	}

	public verificaClicouForaDoMenu = () => {
		if (this.isMenuOpen) {
			this.isMenuOpen = false;
			this.fabTogglerState = 'inactive';
			this.closeMenu();
		}
	}

	verificaButtons() {
		let result : any = this.apiUsuario.verificaLicenca();
		if (result?.prazo >= 0 && !result.periodoTeste) {
			setTimeout(async () => {
				let show = await this.controllerStatus.verificaPermissoesFuncts('novoNegocioFB');
				if(show === false) {
					this.buttons = this.buttons.filter(b => b.url != '/funil-de-vendas');
				}
			},2000)
		}
    }
}
